import { render } from "./FooterFullPage.vue?vue&type=template&id=fed7d4c6&scoped=true"
import script from "./FooterFullPage.vue?vue&type=script&lang=js"
export * from "./FooterFullPage.vue?vue&type=script&lang=js"

import "./FooterFullPage.vue?vue&type=style&index=0&id=fed7d4c6&lang=scss"
import "./FooterFullPage.vue?vue&type=style&index=1&id=fed7d4c6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fed7d4c6"]])

export default __exports__